import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAppService {
  constructor(private httpRequest: HttpClient) {}

  getSubscribedSolutions() {
    const url = `/subscription_manager_app/subscription?conditions={"is_active":${true}}`;
    return this.httpRequest.get(url);
  }

  getSubscribedSolutionsBySolutionId(solutionId: string) {
    const url = `/subscription_manager_app/subscription?conditions={"solution_id":"${solutionId}","is_active":${true}}`;
    return this.httpRequest.get(url);
  }

  getUnSubscribedSolutions() {
    const url = `/subscription_manager_app/subscription?conditions={"is_active":${false}}`;
    return this.httpRequest.get(url);
  }

  subscribeSolution(data: any) {
    const url = '/subscription_manager_app/subscription';
    return this.httpRequest.post(url, data);
  }

  updateSubscription(oldSubscription: any, newSubscription: any) {
    const url = `/subscription_manager_app/subscription?upgrade=true&conditions={"solution_id": "${oldSubscription['solution_id']}", "version_id": "${oldSubscription['version_id']}"}`;
    return this.httpRequest.put(url, newSubscription);
  }

  deleteSubscribeSolution(subscriptionId: string) {
    const url = `/subscription_manager_app/subscription?conditions={"subscription_id": "${subscriptionId}"}`;
    return this.httpRequest.delete(url);
  }

  getUsersSubscription(subscriptionId: string) {
    const url = `/subscription_manager_app/shared-subscriptions/${subscriptionId}`;
    return this.httpRequest.get(url);
  }

  addUsersSubscription(data: any) {
    const url = 'subscription_manager_app/shared-subscriptions';
    return this.httpRequest.post(url, data);
  }

  updateUsersSubscription(subscriptionId: string, data: any) {
    const url = `/subscription_manager_app/shared-subscriptions/${subscriptionId}/`;
    return this.httpRequest.put(url, data);
  }

  deleteUsersSubscription(Id: string) {
    const url = `/subscription_manager_app/shared-subscriptions/${Id}`;
    return this.httpRequest.delete(url);
  }
}
